import urls from './urls';
import axios from 'axios';

class memberProspectsApi {
  static getUserProfileViewProspects(params) {
    // this.restClient = new RestClient();
    // this.restClient.setBaseUrl(urls.BASE_RHPURL);
    const url = urls.PROSPECTS_USER_PROFILE_VIEW_GET;
    // return this.restClient.execute(url, ApiMethod.POST, params).then(res => res);
    return axios.post(url, params, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false } }).then(res => res);
  }

  static deleteUserProfileViewProspects(params) {
    // params :{
    //      Type:‘On’ (Viewed me), ‘Off’ (I Viewed),
    //      Profiles:[0] list userid delete on view
    // }
    // this.restClient = new RestClient();
    // this.restClient.setBaseUrl(urls.BASE_RHPURL);
    const url = urls.PROSPECTS_USER_PROFILE_VIEW;
    // return this.restClient.execute(url, ApiMethod.PATCH, params).then(res => {
    //   return res;
    // });
    return axios.patch(url, params, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false } }).then(res => res);
  }

  static getUserUserMatchProspects(params) {
    // this.restClient = new RestClient();
    // this.restClient.setBaseUrl(urls.BASE_RHPURL);
    const url = urls.PROSPECTS_USER_USER_LIKES_FAVOURITES;
    //  console.log(params)
    // return this.restClient.execute(url, ApiMethod.POST, params).then(res => {
    //   return res;
    // });
    return axios.post(url, params, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false } }).then(res => res);
  }

  static deleteUserMatchProspects(params) {
    // params :{
    //      Profiles:[0] list userid delete on view
    // }
    // this.restClient = new RestClient();
    // this.restClient.setBaseUrl(urls.BASE_RHPURL);
    const url = urls.PROSPECTS_USER_USER_LIKES;
    // return this.restClient.execute(url, ApiMethod.DELETE, params).then(res => {
    //   return res;
    // });
    return axios.delete(url, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false }, data: params }).then(res => res);
  }
  static getUserUserFavouriteProspects(params) {
    // this.restClient = new RestClient();
    // this.restClient.setBaseUrl(urls.BASE_RHPURL);
    const url = urls.PROSPECTS_USER_USER_FAV;
    // return this.restClient.execute(url, ApiMethod.POST, params).then(res => {
    //   return res;
    // });
    return axios.post(url, params, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false } }).then(res => res);
  }
  static deleteUserFavouriteProspects(params) {
    // params :{
    //      Profiles:[0] list userid delete on view
    // }
    // this.restClient = new RestClient();
    // this.restClient.setBaseUrl(urls.BASE_RHPURL);
    const url = urls.PROSPECTS_USER_USER_FAV;
    // return this.restClient.execute(url, ApiMethod.DELETE, params).then(res => {
    //   return res;
    // });
    return axios.delete(url, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false }, data: params }).then(res => res);
  }

  static deleteUserLikesProspect(params) {
    // params :{
    //      Profiles:[0] list userid delete on view
    // }
    // this.restClient = new RestClient();
    // this.restClient.setBaseUrl(urls.BASE_RHPURL);
    const url = urls.PROSPECTS_USER_USER_LIKES;
    // return this.restClient.execute(url, ApiMethod.DELETE, params).then(res => {
    //   return res;
    // });
    return axios.delete(url, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false }, data: params }).then(res => res);
  }

  // static getProspectsCount() {
  //   this.restClient = new RestClient();
  //   this.restClient.setBaseUrl(urls.BASE_RHPURL);
  //   const url = urls.PROSPECTS_COUNT;
  //   //  console.log(params)
  //   return this.restClient.execute(url, ApiMethod.GET).then(res => {
  //     return res;
  //   });
  // }

  static getUserLikeStateCount(body) {
    // this.restClient = new RestClient();
    // this.restClient.setBaseUrl(urls.BASE_RHPURL);
    const url = urls.PROSPECTS_USER_LIKE_STATE_COUNT;

    // return this.restClient.execute(url, ApiMethod.POST, body).then(res => res);
    return axios.post(url, body, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false } }).then(res => res);
  }

  static getUserProfileViewStateCount(body) {
    // this.restClient = new RestClient();
    // this.restClient.setBaseUrl(urls.BASE_RHPURL);
    const url = urls.PROSPECTS_PROFILE_VIEW_STATE_COUNT;

    // return this.restClient.execute(url, ApiMethod.POST, body).then(res => res);
    return axios.post(url, body, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false } }).then(res => res);
  }
}

export default memberProspectsApi;
